import Controller from "./bus.controller";
import template from "./bus.html";

const bus = {
  template,
  controller: Controller,
};

export default bus;



// WEBPACK FOOTER //
// ./src/pages/bus/bus.component.js